import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";

//components
import Table from "../../Components/TableTemplate/DataTable";
import Navbar from "../../Components/Navbar/Navbar";
import DeleteModal from "../../Components/Modals/DeleteModal";
import AddModal from "../../Components/Modals/AddModal";
import EditModal from "../../Components/Modals/EditModal";
import ViewModal from "../../Components/Modals/ViewModal";
import FileExceedModal from "../../Components/Modals/FileExceedModal";

//css
import "./Manage.css";
import "../../Components/Navbar/Navbar.css";
import {
  createCreditCard,
  updateCreditCard,
  deleteCreditCard,
  searchCreditCard,
  getCardTransactions,
  addCardTransaction,
  deleteCardTransaction,
} from "../../Helpers/apiCalls/Manage/CreditCards";
import toast from "react-hot-toast";
import { toastStyle, isAdmin } from "../../Helpers/Utils/Common";
import { validateCreditCards } from "../../Helpers/Validation/Manage/CreditCardsValidation";
import InputError from "../../Components/InputError/InputError";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const money = (n) =>
  new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n || 0);

const TXN_TITLE = {
  expense: "EXPENSE",
  payment: "PAYMENT",
};

const MAX_FILE_SIZE = 5 * 1024 * 1024;
const ALLOWED_FILE_TYPES = ["image/jpeg", "image/png"];

export default function CreditCards() {
  const [inactive, setInactive] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewCardModal, setShowViewCardModal] = useState(false);
  const handleShowViewCardModal = () => setShowViewCardModal(true);
  const handleCloseViewCardModal = () => {
    setShowViewCardModal(false);
    setViewCardData({});
  };
  const [viewCardData, setViewCardData] = useState({});
  const [showEditCardModal, setShowEditCardModal] = useState(false);
  const handleShowEditCardModal = () => setShowEditCardModal(true);
  const handleCloseEditCardModal = () => {
    setShowEditCardModal(false);
    resetValues();
  };
  const [showAddCardModal, setShowAddCardModal] = useState(false);
  const handleShowAddCardModal = () => setShowAddCardModal(true);
  const handleCloseAddCardModal = () => {
    setShowAddCardModal(false);
    resetValues();
  };

  const [isError, setIsError] = useState({
    name: false,
    card_name: false,
    card_no: false,
    issuing_bank: false,
    credit_limit: false,
    statement_date: false,
    due_date: false,
  });

  const [isErrorEdit, setIsErrorEdit] = useState({
    name: false,
    card_name: false,
    card_no: false,
    issuing_bank: false,
    credit_limit: false,
    statement_date: false,
    due_date: false,
  });

  //API
  const [cardsData, setCardsData] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [addCardData, setAddCardData] = useState({
    name: "",
    card_name: "",
    card_no: "",
    issuing_bank: "",
    credit_limit: "",
    statement_date: "",
    due_date: "",
  });
  const [editCardData, setEditCardData] = useState({
    id: "",
    name: "",
    card_name: "",
    card_no: "",
    issuing_bank: "",
    credit_limit: "",
    statement_date: "",
    due_date: "",
  });

  // Add Expense / Add Payment
  const [showTxnModal, setShowTxnModal] = useState(false);
  const [txnForm, setTxnForm] = useState({
    credit_card_id: "",
    card_name: "",
    type: "expense",
    txn_date: dayjs(),
    amount: "",
    remarks: "",
    current_bal: 0,
  });
  const [txnFileList, setTxnFileList] = useState([]);
  const [showFileExceedModal, setShowFileExceedModal] = useState(false);

  // View Transactions
  const [showTxnHistoryModal, setShowTxnHistoryModal] = useState(false);
  const [txnHistoryCard, setTxnHistoryCard] = useState({});
  const [txnHistoryData, setTxnHistoryData] = useState([]);
  const [txnHistoryLoading, setTxnHistoryLoading] = useState(false);

  function resetValues() {
    setEditCardData({});
    setAddCardData({});
  }

  const filteredData = cardsData.filter(
    (item) =>
      item.name.toLowerCase().includes(searchText.toLowerCase()) ||
      item.issuing_bank.toLowerCase().includes(searchText.toLowerCase())
  );

  const handleAddChange = (e) => {
    const { name, value } = e.target;
    setAddCardData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditCardData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  function DeleteTxnBtn(row) {
    return (
      <button
        className="button-warning-fill"
        onClick={() => delTransaction(row)}
      >
        Delete
      </button>
    );
  }

  //DROPDOWN
  function handleSelectChange(e, row) {
    setShowLoader(true);
    setSelectedRow(row);

    if (e.target.value === "edit-card") {
      setEditCardData(row);
      handleShowEditCardModal();
    } else if (e.target.value === "view-card") {
      setViewCardData(row);
      handleShowViewCardModal();
    } else if (e.target.value === "add-payment") {
      setTxnForm({
        credit_card_id: row.id,
        card_name: row.name,
        type: "payment",
        txn_date: dayjs(),
        amount: "",
        remarks: "",
        current_bal: row.current_bal,
      });
      setShowTxnModal(true);
    } else if (e.target.value === "view-transactions") {
      setTxnHistoryCard(row);
      fetchTransactions(row.id);
      setShowTxnHistoryModal(true);
    }
    setShowLoader(false);
  }

  function ActionBtn(row) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action form-select"
        id={row.id}
        onChange={(e) => handleSelectChange(e, row)}
        value={""}
      >
        <option defaulValue selected hidden>
          Select
        </option>
        <option value="view-card" className="color-options">
          View
        </option>
        {isAdmin() && (
          <option value="edit-card" className="color-options">
            Edit
          </option>
        )}
        <option value="view-transactions" className="color-options">
          View Transactions
        </option>
        <option value="add-payment" className="color-options">
          Add Payment
        </option>
      </Form.Select>
    );
  }

  async function create() {
    if (validateCreditCards(addCardData, setIsError)) {
      setIsClicked(true);
      const response = await createCreditCard(addCardData);
      if (response) {
        if (response?.data?.status === "success") {
          toast.success("Successfully added credit card!", {
            style: toastStyle(),
          });
          handleCloseAddCardModal();
          resetValues();
          searchCreditCards();
        }
        if (response?.error?.data?.messages?.name) {
          toast.error(response.error.data.messages.name, {
            style: toastStyle(),
          });
        }
      }
      setIsClicked(false);
    }
  }

  async function searchCreditCards() {
    setCardsData([]);
    setShowLoader(true);
    const response = await searchCreditCard(searchText);

    if (response?.data) {
      if (response.data.data.data) {
        let result = response.data.data.data.map((a) => {
          return {
            id: a.id,
            name: a.name,
            card_name: a.card_name,
            card_no: a.card_no,
            issuing_bank: a.issuing_bank,
            credit_limit: a.credit_limit,
            current_bal: a.current_bal,
            statement_date: a.statement_date,
            due_date: a.due_date,
            formatted_credit_limit: money(a.credit_limit),
            formatted_current_bal: money(a.current_bal),
            action_btn: ActionBtn(a),
          };
        });
        setCardsData(result);
      } else {
        // no matches, or backend returned a non-success status — leave the
        // table empty so the DataTable's built-in NoDataPrompt shows instead
        setCardsData([]);
      }
    } else {
      // request itself failed (network/404/500) — same empty-state fallback
      setCardsData([]);
    }
    setShowLoader(false);
  }

  async function del() {
    const response = await deleteCreditCard(selectedRow.id);
    if (response) {
      if (response?.data?.status === "success") {
        toast.success(response.data.response, {
          style: toastStyle(),
        });
        setShowDeleteModal(false);
        resetValues();
        searchCreditCards();
      } else {
        toast.error(response.error.data.messages.error, {
          style: toastStyle(),
        });
      }
    }
  }

  async function editCard() {
    if (validateCreditCards(editCardData, setIsErrorEdit)) {
      const response = await updateCreditCard(editCardData);

      if (response) {
        if (response?.data?.status === "success") {
          toast.success(response.data.response, {
            style: toastStyle(),
          });
          handleCloseEditCardModal();
          resetValues();
          searchCreditCards();
        } else {
          toast.error(response.error.data.messages.error, {
            style: toastStyle(),
          });
        }
      }
    }
  }

  const handleTxnBeforeUpload = (file) => {
    if (file.size > MAX_FILE_SIZE) {
      setShowFileExceedModal(true);
      return Upload.LIST_IGNORE;
    }
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      toast.error("Only JPG or PNG images are allowed.", { style: toastStyle() });
      return Upload.LIST_IGNORE;
    }
    return false; 
  };

  const handleTxnFileChange = ({ fileList }) => {
    setTxnFileList(fileList);
  };

  const handleTxnFileRemove = (removedFile) => {
    setTxnFileList((prev) => prev.filter((f) => f.uid !== removedFile.uid));
  };

  async function saveTransaction() {
    if (!(Number(txnForm.amount) > 0)) {
      toast.error("Enter an amount greater than 0.", { style: toastStyle() });
      return;
    }
    if (
      txnForm.type === "payment" &&
      Number(txnForm.amount) > Number(txnForm.current_bal || 0)
    ) {
      toast.error("Payment amount cannot exceed the current balance.", {
        style: toastStyle(),
      });
      return;
    }
    if (txnForm.type === "payment" && txnFileList.length === 0) {
      toast.error("Please attach at least one payment receipt (JPG/PNG).", {
        style: toastStyle(),
      });
      return;
    }

    setIsClicked(true);

    const formData = new FormData();
    formData.append("credit_card_id", txnForm.credit_card_id);
    formData.append("type", txnForm.type);
    formData.append("txn_date", txnForm.txn_date.format("YYYY-MM-DD"));
    formData.append("amount", txnForm.amount);
    formData.append("remarks", txnForm.remarks || "");
    txnFileList.forEach((f) => {
      if (f.originFileObj) {
        formData.append("file[]", f.originFileObj);
      }
    });

    const response = await addCardTransaction(formData);
    if (response?.data?.status === "success") {
      toast.success("Successfully saved.", { style: toastStyle() });
      setShowTxnModal(false);
      setTxnFileList([]);
      searchCreditCards(); // refresh so CURRENT BALANCE reflects the change
    } else {
      toast.error(
        response?.error?.data?.messages?.error || "Could not save.",
        { style: toastStyle() }
      );
    }
    setIsClicked(false);
  }

  async function fetchTransactions(creditCardId) {
    setTxnHistoryLoading(true);
    setTxnHistoryData([]);
    const response = await getCardTransactions(creditCardId);
    if (response) {
      let result = (response.data?.data?.data || []).map((t) => {
        return {
          id: t.id,
          txn_date: t.txn_date,
          type: t.type === "expense" ? "Expense" : "Payment",
          formatted_amount: money(t.amount),
          remarks: t.remarks || "",
          delete_btn: DeleteTxnBtn(t),
        };
      });
      setTxnHistoryData(result);
    }
    setTxnHistoryLoading(false);
  }

  async function delTransaction(row) {
    const response = await deleteCardTransaction(row.id);
    if (response) {
      if (response?.data?.status === "success") {
        toast.success(response.data.response || "Successfully deleted.", {
          style: toastStyle(),
        });
        fetchTransactions(txnHistoryCard.id);
        searchCreditCards(); // balance changed
      } else {
        toast.error(
          response?.error?.data?.messages?.error || "Could not delete.",
          { style: toastStyle() }
        );
      }
    }
  }

  React.useEffect(() => {
    searchCreditCards();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"MANAGE"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={6}>
            <h1 className="page-title"> CREDIT CARDS </h1>
          </Col>
          <Col className="d-flex justify-content-end">
            <input
              type="search"
              name="name"
              placeholder="Search Card Name...​"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              className="search-bar"
            />
            <button className="add-btn" onClick={handleShowAddCardModal}>
              Add
            </button>
          </Col>
        </Row>

        {/* TABLE */}
        <div className="tab-content">
          <Table
            tableHeaders={[
              "NAME",
              "ISSUING BANK",
              "CARD NO.",
              "CREDIT LIMIT",
              "CURRENT BALANCE",
              "STATEMENT DAY",
              "DUE DAY",
              "ACTIONS",
            ]}
            headerSelector={[
              "name",
              "issuing_bank",
              "card_no",
              "formatted_credit_limit",
              "formatted_current_bal",
              "statement_date",
              "due_date",
              "action_btn",
            ]}
            tableData={filteredData}
            showLoader={showLoader}
            withActionData={true}
          />
        </div>
      </div>

      {/* MODALS */}
      <DeleteModal
        text="credit card"
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={() => del()}
      />
      <AddModal
        title="CREDIT CARD"
        size="lg"
        type="creditcard"
        show={showAddCardModal}
        onHide={handleCloseAddCardModal}
        onSave={() => create()}
        isClicked={isClicked}
        data={addCardData}
      >
        <div className="mt-3 ">
          <Row className="nc-modal-custom-row mt-0">
            <Col>
              NAME
              <span className="required-icon">*</span>
              <Form.Control
                type="text"
                name="name"
                value={addCardData.name}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={!!isError.name}
                message={isError.name}
              />
            </Col>
            <Col>
              NAME ON CARD
              <span className="required-icon">*</span>
              <Form.Control
                type="text"
                name="card_name"
                value={addCardData.card_name}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={!!isError.card_name}
                message={isError.card_name}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-2">
            <Col>
              CARD NUMBER
              <span className="required-icon">*</span>
              <Form.Control
                type="text"
                name="card_no"
                value={addCardData.card_no}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={!!isError.card_no}
                message={isError.card_no}
              />
            </Col>
            <Col>
              ISSUING BANK
              <span className="required-icon">*</span>
              <Form.Control
                type="text"
                name="issuing_bank"
                value={addCardData.issuing_bank}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={!!isError.issuing_bank}
                message={isError.issuing_bank}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-2">
            <Col>
              CREDIT LIMIT
              <span className="required-icon">*</span>
              <Form.Control
                type="text"
                name="credit_limit"
                value={addCardData.credit_limit}
                className="nc-modal-custom-input"
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9.]/g, "");
                  handleAddChange({ target: { name: "credit_limit", value } });
                }}
                required
              />
              <InputError
                isValid={!!isError.credit_limit}
                message={isError.credit_limit}
              />
            </Col>
            <Col>
              STATEMENT DAY
              <span className="required-icon">*</span>
              <Form.Control
                type="number"
                min="1"
                max="31"
                name="statement_date"
                value={addCardData.statement_date}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={!!isError.statement_date}
                message={isError.statement_date}
              />
            </Col>
            <Col>
              DUE DAY
              <span className="required-icon">*</span>
              <Form.Control
                type="number"
                min="1"
                max="31"
                name="due_date"
                value={addCardData.due_date}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={!!isError.due_date}
                message={isError.due_date}
              />
            </Col>
          </Row>
        </div>
      </AddModal>
      <EditModal
        title="CREDIT CARD"
        size="lg"
        type="creditcard"
        show={showEditCardModal}
        onHide={handleCloseEditCardModal}
        onSave={() => editCard()}
        data={editCardData}
      >
        <div className="mt-3">
          <Row className="nc-modal-custom-row mt-0">
            <Col>
              NAME
              <span className="required-icon">
                {editCardData.name === "" ? "*" : ""}
              </span>
              <Form.Control
                type="text"
                name="name"
                value={editCardData.name}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={!!isErrorEdit.name}
                message={isErrorEdit.name}
              />
            </Col>
            <Col>
              NAME ON CARD
              <span className="required-icon">
                {editCardData.card_name === "" ? "*" : ""}
              </span>
              <Form.Control
                type="text"
                name="card_name"
                value={editCardData.card_name}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={!!isErrorEdit.card_name}
                message={isErrorEdit.card_name}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-2">
            <Col>
              CARD NUMBER
              <span className="required-icon">
                {editCardData.card_no === "" ? "*" : ""}
              </span>
              <Form.Control
                type="text"
                name="card_no"
                value={editCardData.card_no}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={!!isErrorEdit.card_no}
                message={isErrorEdit.card_no}
              />
            </Col>
            <Col>
              ISSUING BANK
              <span className="required-icon">
                {editCardData.issuing_bank === "" ? "*" : ""}
              </span>
              <Form.Control
                type="text"
                name="issuing_bank"
                value={editCardData.issuing_bank}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={!!isErrorEdit.issuing_bank}
                message={isErrorEdit.issuing_bank}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-2">
            <Col>
              CREDIT LIMIT
              <span className="required-icon">
                {editCardData.credit_limit === "" ? "*" : ""}
              </span>
              <Form.Control
                type="text"
                name="credit_limit"
                value={editCardData.credit_limit}
                className="nc-modal-custom-input"
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9.]/g, "");
                  handleEditChange({ target: { name: "credit_limit", value } });
                }}
                required
              />
              <InputError
                isValid={!!isErrorEdit.credit_limit}
                message={isErrorEdit.credit_limit}
              />
            </Col>
            <Col>
              STATEMENT DAY
              <span className="required-icon">
                {editCardData.statement_date === "" ? "*" : ""}
              </span>
              <Form.Control
                type="number"
                min="1"
                max="31"
                name="statement_date"
                value={editCardData.statement_date}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={!!isErrorEdit.statement_date}
                message={isErrorEdit.statement_date}
              />
            </Col>
            <Col>
              DUE DAY
              <span className="required-icon">
                {editCardData.due_date === "" ? "*" : ""}
              </span>
              <Form.Control
                type="number"
                min="1"
                max="31"
                name="due_date"
                value={editCardData.due_date}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={!!isErrorEdit.due_date}
                message={isErrorEdit.due_date}
              />
            </Col>
          </Row>
        </div>
      </EditModal>

      {/* VIEW CREDIT CARD */}
      <ViewModal
        title="CREDIT CARD"
        size="lg"
        withHeader={true}
        withCloseButtons={true}
        show={showViewCardModal}
        onHide={handleCloseViewCardModal}
      >
        <div className="mt-3">
          <Row className="nc-modal-custom-row mt-0">
            <Col>
              NAME
              <Form.Control
                type="text"
                className="nc-modal-custom-input"
                value={viewCardData.name || ""}
                disabled
              />
            </Col>
            <Col>
              NAME ON CARD
              <Form.Control
                type="text"
                className="nc-modal-custom-input"
                value={viewCardData.card_name || ""}
                disabled
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-2">
            <Col>
              CARD NUMBER
              <Form.Control
                type="text"
                className="nc-modal-custom-input"
                value={viewCardData.card_no || ""}
                disabled
              />
            </Col>
            <Col>
              ISSUING BANK
              <Form.Control
                type="text"
                className="nc-modal-custom-input"
                value={viewCardData.issuing_bank || ""}
                disabled
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-2">
            <Col>
              CREDIT LIMIT
              <Form.Control
                type="text"
                className="nc-modal-custom-input"
                value={money(viewCardData.credit_limit)}
                disabled
              />
            </Col>
            <Col>
              CURRENT BALANCE
              <Form.Control
                type="text"
                className="nc-modal-custom-input"
                value={money(viewCardData.current_bal)}
                disabled
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-2">
            <Col>
              STATEMENT DAY
              <Form.Control
                type="text"
                className="nc-modal-custom-input"
                value={viewCardData.statement_date || ""}
                disabled
              />
            </Col>
            <Col>
              DUE DAY
              <Form.Control
                type="text"
                className="nc-modal-custom-input"
                value={viewCardData.due_date || ""}
                disabled
              />
            </Col>
          </Row>
        </div>
      </ViewModal>

      {/* ADD EXPENSE / ADD PAYMENT */}
      <AddModal
        title={TXN_TITLE[txnForm.type]}
        size="lg"
        show={showTxnModal}
        isClicked={isClicked}
        onHide={() => {
          setShowTxnModal(false);
          setTxnForm({
            credit_card_id: "",
            card_name: "",
            type: "expense",
            txn_date: dayjs(),
            amount: "",
            remarks: "",
            current_bal: 0,
          });
          setTxnFileList([]);
        }}
        onSave={() => saveTransaction()}
      >
        <div className="mt-3">
          <Row className="nc-modal-custom-row mt-0">
            <Col xs={6}>
              CREDIT CARD
              <Form.Control
                type="text"
                className="nc-modal-custom-input"
                value={txnForm.card_name}
                disabled
              />
            </Col>
            <Col xs={6}>
              DATE
              <span className="required-icon">*</span>
              <DatePicker
                popupStyle={{ zIndex: 2000 }}
                className="nc-modal-custom-input w-100"
                allowClear={false}
                value={txnForm.txn_date}
                onChange={(d) =>
                  setTxnForm((p) => ({ ...p, txn_date: d }))
                }
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-2">
            <Col xs={6}>
              AMOUNT
              <span className="required-icon">*</span>
              <Form.Control
                type="number"
                min="0"
                step="0.01"
                className="nc-modal-custom-input"
                value={txnForm.amount}
                onChange={(e) =>
                  setTxnForm((p) => ({ ...p, amount: e.target.value }))
                }
              />
            </Col>
            <Col xs={6}>
              REMARKS
              <Form.Control
                type="text"
                className="nc-modal-custom-input"
                value={txnForm.remarks}
                onChange={(e) =>
                  setTxnForm((p) => ({ ...p, remarks: e.target.value }))
                }
              />
            </Col>
          </Row>
          {txnForm.type === "payment" && (
            <Row className="nc-modal-custom-row mt-2">
              <Col xs={12}>
                PAYMENT RECEIPT
                <span className="required-icon">*</span>
                <Upload
                  listType="picture-card"
                  fileList={txnFileList}
                  beforeUpload={handleTxnBeforeUpload}
                  onChange={handleTxnFileChange}
                  onRemove={handleTxnFileRemove}
                  accept="image/jpeg,image/png"
                  multiple
                >
                  <div>
                    <PlusOutlined />
                    <div style={{ marginTop: 8 }}>Upload</div>
                    <div style={{ fontSize: "12px", color: "#666" }}>
                      (JPG/PNG, Max: 5MB per file)
                    </div>
                  </div>
                </Upload>
              </Col>
            </Row>
          )}
        </div>
      </AddModal>

      <FileExceedModal
        show={showFileExceedModal}
        onHide={() => setShowFileExceedModal(false)}
        size="5MB"
      />

      {/* VIEW TRANSACTIONS */}
      <ViewModal
        title="TRANSACTIONS"
        size="lg"
        withHeader={true}
        withCloseButtons={true}
        show={showTxnHistoryModal}
        onHide={() => setShowTxnHistoryModal(false)}
      >
        <div className="mt-3">
          <Row className="nc-modal-custom-row mt-0 mb-3">
            <Col>
              CREDIT CARD
              <Form.Control
                type="text"
                className="nc-modal-custom-input"
                value={txnHistoryCard.name || ""}
                disabled
              />
            </Col>
          </Row>
          <Table
            tableHeaders={["DATE", "TYPE", "AMOUNT", "REMARKS", "ACTIONS"]}
            headerSelector={[
              "txn_date",
              "type",
              "formatted_amount",
              "remarks",
              "delete_btn",
            ]}
            tableData={txnHistoryData}
            showLoader={txnHistoryLoading}
            withActionData={true}
          />
        </div>
      </ViewModal>
    </div>
  );
}